import { render, staticRenderFns } from "./neonClock.vue?vue&type=template&id=4883e0ac&scoped=true"
import script from "./neonClock.vue?vue&type=script&lang=js"
export * from "./neonClock.vue?vue&type=script&lang=js"
import style0 from "./neonClock.vue?vue&type=style&index=0&id=4883e0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883e0ac",
  null
  
)

export default component.exports